<template>
    <div class="template-sections-container" :class="[$mq]">
        <div v-if="sections.length > 0" class="sidebar-sections hide-scrollbar">
            <div class="control-overflow" v-if="!isAudit">
                <div v-for="(section, index) in sections" class="item" :data-id="section.item_id" :class="[{ subtitle: section.type == 9 }, { selected: currentSection == section.item_id }]" :key="index" @click="toSection(section.item_id)" v-if="section.type != 9">
                    <div class="icon-container">
                        <i v-if="sectionItemsAreDone(section.item_id)" class="i-andy-menu-checklist i-andy-sm"></i>
                        <i v-else class="i-andy-circle-exclamation i-andy-sm"></i>
                    </div>
                    <p class="title-text">{{ section.title }}</p>
                </div>
            </div>
            <div class="control-overflow" v-else>
                <div v-for="(section, index) in sections" class="item" :data-id="section.section_id" :class="[{ subtitle: section.type == 9 }, { selected: currentSection == section.section_id }]" :key="index" @click="toSection(section.section_id)">
                    <div class="icon-container">
                        <i v-if="sectionItemsAreDone(section.section_id)" class="i-andy-menu-checklist i-andy-sm"></i>
                        <i v-else class="i-andy-circle-exclamation i-andy-sm"></i>
                    </div>
                    <p class="title-text">{{ section.name }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TemplateSections',
    props: {
        sections: {
            type: undefined,
            default: false
        },
        isAudit: {
            type: Boolean,
            default: false
        },
        doneSectionsIds: {
            type: Array,
            default: () => []
        },
        firstNotDoneSectionId: {
            type: String,
            default: null
        },
        skipScrollToFirstPendingSection: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentSection: false,
            examEl: null,
            scrollObserver: null,
            scrollSyncFrame: null,
            initScrollFrame: null,
            isDestroyed: false
        }
    },
    methods: {
        toSection(id, smooth = true) {
            this.currentSection = id

            if (this.isAudit) {
                const section = this.sections.filter((section) => section.section_id == id)[0]
                this.$emit('element-click', section)
                return
            }

            const sectionEl = document.getElementById(id)

            if (sectionEl) {
                sectionEl.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' })
                return
            }
        },
        scrollToSectionChip(id) {
            const section = this.$el.querySelector(`[data-id="${id}"]`)

            if (section) {
                section.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
            }
        },
        selectCategoriesWhileScrolling() {
            var self = this

            // Un solo ciclo por frame: evita observers concurrentes si llegan
            // varios eventos de scroll seguidos.
            if (self.scrollSyncFrame) {
                return
            }

            self.scrollSyncFrame = requestAnimationFrame(() => {
                self.scrollSyncFrame = null

                const exam = self.examEl || document.querySelector('#exam')

                if (!exam) {
                    return
                }

                if (self.scrollObserver) {
                    self.scrollObserver.disconnect()
                    self.scrollObserver = null
                }

                const callback = (entries, observer) => {
                    try {
                        // compare parentElement.id if is in section.item_id
                        const matched = entries
                            .filter((entry) => entry.isIntersecting && entry.target.id)
                            .map((entry) => {
                                const section = self.isAudit
                                    ? self.sections.find((item) => item.section_id == entry.target.id)
                                    : self.sections.find((item) => item.item_id == entry.target.id)

                                return section ? { entry, section } : null
                            })
                            .filter(Boolean)
                            .sort((a, b) => b.entry.intersectionRatio - a.entry.intersectionRatio)

                        if (!matched.length) {
                            return
                        }

                        const best = matched[0]
                        // Usar el id tipado del modelo (no el string del DOM) para que
                        // el selected del template no falle con === / tipos mixtos.
                        const sectionId = self.isAudit ? best.section.section_id : best.section.item_id
                        self.currentSection = sectionId
                        // do scroll to horizontal sections
                        self.scrollToSectionChip(sectionId)
                    } finally {
                        observer.disconnect()
                        if (self.scrollObserver === observer) {
                            self.scrollObserver = null
                        }
                    }
                }
                // En auditorías las secciones pueden ser más altas que #exam; 0.6 sería
                // inalcanzable. En registros se observan .question (ítems pequeños).
                const observed = self.isAudit ? exam.querySelectorAll('.section[id]') : exam.querySelectorAll('.question')
                const observer = new IntersectionObserver(callback, {
                    rootMargin: '0px',
                    root: exam,
                    threshold: self.isAudit ? [0, 0.1, 0.25, 0.5, 0.75, 1] : 0.6
                })
                self.scrollObserver = observer
                observed.forEach((item) => observer.observe(item))
            })
        },

        // CUANDO HACES SCROLL TE SELECCIONE LA CATEGORÍA QUE VES
        handleScroll() {
            const exam = document.querySelector('#exam')

            if (!exam) {
                return false
            }

            // Solo 'scroll': cubre wheel e inercia touch sin duplicar observers.
            this.examEl = exam
            exam.addEventListener('scroll', this.selectCategoriesWhileScrolling, { passive: true })
            return true
        },
        attachScrollSync() {
            if (this.isDestroyed || this.handleScroll()) {
                return
            }

            // #exam puede no estar en el DOM todavía: reintentar en el próximo frame
            this.initScrollFrame = requestAnimationFrame(() => {
                this.initScrollFrame = null

                if (!this.isDestroyed) {
                    this.handleScroll()
                }
            })
        },
        removeScrollListeners() {
            if (this.examEl) {
                this.examEl.removeEventListener('scroll', this.selectCategoriesWhileScrolling)
                this.examEl = null
            }

            if (this.scrollObserver) {
                this.scrollObserver.disconnect()
                this.scrollObserver = null
            }

            if (this.scrollSyncFrame) {
                cancelAnimationFrame(this.scrollSyncFrame)
                this.scrollSyncFrame = null
            }

            if (this.initScrollFrame) {
                cancelAnimationFrame(this.initScrollFrame)
                this.initScrollFrame = null
            }
        },
        sectionItemsAreDone(sectionId) {
            return this.doneSectionsIds.includes(sectionId)
        }
    },
    mounted() {
        // #exam es hermano posterior en el template del padre; esperar al DOM.
        this.$nextTick(this.attachScrollSync)
        if (this.sections && this.sections.length > 0) {
            if (!this.isAudit) {
                this.currentSection = this.sections[0].item_id
            } else {
                this.currentSection = this.sections[0].section_id
            }
        }
        // Guardamos el valor al montar: si el usuario vuelve de un Plan de Acción,
        // la no conformidad tiene prioridad sobre el scroll a la siguiente sección pendiente.
        const skipPendingSectionScroll = this.skipScrollToFirstPendingSection
        if (!skipPendingSectionScroll && this.firstNotDoneSectionId && this.doneSectionsIds.length > 0) {
            // Diferimos al siguiente tick + frame para que el resto de hermanos
            // (SearchBar, Banner, NoteDetail, Answer, etc.) ya estén montados y el
            // layout esté estable antes de calcular la posición del scroll.
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    this.toSection(this.firstNotDoneSectionId, false)
                })
            })
        }
    },
    beforeDestroy() {
        this.isDestroyed = true
        this.removeScrollListeners()
    }
}
</script>

<style lang="scss" scoped>
.template-sections-container {
    @include display-flex();
    @include align-items();
    width: 100%;
    // height: 100%;
    // padding: 4px;
    position: relative;
    top: 0px;
    height: 100%;

    .sidebar-sections {
        @include border-radius(4px);
        height: 47px;
        position: relative;
        background-color: #fff;
        width: 100%;
        overflow-y: hidden;
        overflow-x: auto;

        display: grid;
        place-items: center;

        .control-overflow {
            @include display-flex();
            @include align-items(center);
            @include justify-content(flex-start);
            @include flex-direction(row);
            @include width-max-content();
            min-width: 100%;
            padding: 8px;
            height: fit-content;
            height: 47px;
            gap: 4px;
        }

        .item {
            @include interaction();
            @include width-fit-content();
            @include text-ellipsis();
            // @include font-size(sm);
            @include display-flex();
            @include align-items(center);
            // height: 36px !important;
            font-family: $text;
            color: $neutro-s50;
            padding: 4px 8px;
            cursor: pinter;
            // transition color and background-color and font size
            transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out, font-size 0.3s ease-in-out;

            display: flex !important;
            align-items: center;
            gap: 4px;

            height: 31px;

            &.selected {
                @include border-radius(4px);
                background-color: $main-t80;
                color: $main-dark;
                font-size: 16px;

                .title-text {
                    font-size: 16px;
                    color: $color-black;
                    font-family: $text-bold;
                }
            }

            .icon-container {
                border-radius: 50%;
                background-color: $color-white;
                // border: 1px solid $color-white;
                line-height: 1.5;
                display: grid;
                place-items: center;

                width: 20px;
                height: 20px;
            }

            .i-andy-menu-checklist {
                color: $done;
            }

            .i-andy-circle-exclamation {
                color: #ffcd1a;
                border-radius: 50%;
            }

            .title-text {
                font-size: 16px;
                color: #727477;

                padding: 0px 4px;
            }
        }
    }
    &.portrait {
        padding: unset;

        .item {
            @include font-size(xs);

            &.selected {
                @include font-size(xs);
            }
        }
    }
}
</style>
